<div class="presenter-config-outer-container">
  <div class="header-container">
    <ng-content select="[header]"></ng-content>
  </div>
  <ng-scrollbar appearance="compact">
    <div class="presenter-config-container">
      <ng-content></ng-content>
    </div>
  </ng-scrollbar>
  <div class="footer-container">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
